import * as _4 from 'lodash4';
import { AccountModel } from 'data-ng-authentication';

export class AboutController {
  private isLoggedIn: boolean;
  constructor(private accountModel: AccountModel) {}

  $onInit() {
    this.isLoggedIn = this.accountModel.isLoggedIn();
  }
}
export class AboutComponent implements ng.IComponentOptions {
  public controller: object = AboutController;
  public templateUrl: string = 'lib/about/about.html';
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/lib/about/about.ts